import { Edit, Eye, Trash } from "tabler-icons-react";

export const InterestHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "interestName",
    numeric: false,
    disablePadding: true,
    label: "Interest",
  },
  {
    id: "interestDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "state",
    numeric: false,
    disablePadding: true,
    label: "Status",
  },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,

    numeric: false,
    label: "Actions",
  },
];
